import script from "./companyZj.vue?vue&type=script&setup=true&lang=js"
export * from "./companyZj.vue?vue&type=script&setup=true&lang=js"

import "./companyZj.vue?vue&type=style&index=0&id=95d6bbdc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95d6bbdc"]])

export default __exports__